import React, {FC} from 'react';
import styled from 'styled-components';

import {hoverSelector} from '../../../libs/shared/helpers/src/browser/hoverHelpers';
import {ChromelessButton} from '../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import {
  StartGuideArticleDefinition,
  StartGuideArticleTypesEnum,
} from '../startGuide/startGuideArticlesCommon';
import {StartGuideItem} from '../startGuide/startGuideItem';

/*
 * Style.
 */

const StyledArticle = styled(ChromelessButton)`
  display: grid;
  grid-template-areas: 'thumbnail text';
  grid-template-columns: 56px auto;
  padding: 8px;
  border: 1px solid ${(p) => p.theme.alphas.black20};
  border-radius: 16px;
  height: 92px;
  overflow: hidden;
  line-height: 18px;
`;

const StyledArticleText = styled.div`
  grid-area: text;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
`;

const StyledArticleTitle = styled.span`
  grid-area: title;
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.medium};
  ${hoverSelector} {
    color: ${(p) => p.theme.palette[PaletteColorsEnum.BLUE].shade40};
  }
`;

const StyledArticleDescription = styled.span`
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.verySmall};
  padding-top: 2px;
`;

const StyledIconSpan = styled.span`
  display: inline;
  white-space: nowrap;
`;

const StyledArticleLinkIcon = styled(Icon)`
  display: inline-block;
  color: transparent;
  margin-bottom: -3px;
  ${hoverSelector} {
    color: ${(p) => p.theme.palette[PaletteColorsEnum.BLUE].shade40};
  }
`;

const StyledArticleThumbnail = styled.div`
  grid-area: thumbnail;
  height: 74px;
`;

const StyleArticleThumbnailImg = styled.img`
  width: 46px;
  height: 100%;
`;

/*
 * Component.
 */

export const StartGuideArticle: FC<StartGuideArticleDefinition> = (props) => (
  <StyledArticle onClick={props.onClick}>
    <StyledArticleThumbnail>{renderThumbnail(props)}</StyledArticleThumbnail>
    <StyledArticleText>
      <StyledArticleTitle>
        {props.title}
        <StyledIconSpan>
          &nbsp;
          <StyledArticleLinkIcon name="externalLinkSmall" />
        </StyledIconSpan>

        <br />
      </StyledArticleTitle>
      <StyledArticleDescription>{props.description}</StyledArticleDescription>
    </StyledArticleText>
  </StyledArticle>
);

/*
 * Helpers.
 */

function renderThumbnail(props: StartGuideArticleDefinition) {
  if (props.type === StartGuideArticleTypesEnum.PNG) {
    return <StyleArticleThumbnailImg src={props.thumbnail} alt="" />;
  }
  return (
    <StartGuideItem
      outerBackgroundColor={props.outerBackgroundColor}
      innerBackgroundColor={props.innerBackgroundColor}
      iconName={props.iconName}
    />
  );
}
